import React from 'react'

import Altesse from './logo.inline.svg'

const Logo = () => <Altesse />

export default Logo
